<div class="title">О футбольной лиге «Трудовые резервы»</div>
<div class="text">
  <p>
  С 27 марта по 22 ноября в два этапа пройдёт шестой сезон OLIMPBET Футбольной Лиги «Трудовые Резервы» для корпоративных команд. Весенний этап пройдёт с 1 апреля по 19 июня, осенний – с 20 сентября по 22 ноября.
  </p>
  <p>
  В соревнованиях участвуют 32 команды. На каждом матче будет работать профессиональный судейский корпус. Соревнования будут проходить в КЛФК «ЦСКА» и в Манеже «Локомотив».
  </p>
  <p>
  Квалификационный этап пройдёт по Швейцарской системе (4 тура). Команды распределены по территориальному признаку. Группа «Восток» играет в Манеже «Локомотив»(12 команд). Группа «Север» играет в КЛФК «ЦСКА»(20 команд). Второй этап – два групповых турнира (6 туров): в каждой группе команды будут поделены по силам на Дивизионы по 4 команды. Победитель высшего дивизиона «Меркурий» получит возможность участия в Титульном мероприятии до конца 2025 года без взноса.
  </p>
  <p>
  Зрители и болельщики смогут наблюдать за встречами в прямом эфире официального аккаунта Лиги в группе в ВК. На чемпионате будет активно работать медиагруппа, которая обеспечит профессиональными фотоотчётами и обзорами лучших моментов с каждого матча.
  </p>
  <p>
  На протяжении всех матчей формируется статистика команд и отдельно каждого игрока на официальном сайте Лиги.
  </p>
  <p>
  Победители и призёры по итогам матчей группового этапа в каждом Дивизионе получают уникальные награды ВФСО «Трудовые резервы».
  </p>
</div>

<div class="statistic">
  <div class="item">
    <div class="name">
      Всего команд
      <br />
      в лиге
    </div>
    <div class="value">{{ statistic?.teams_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество игроков
      <br />
      в лиге
    </div>
    <div class="value">{{ statistic?.players_count || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      забитых голов
    </div>
    <div class="value">{{ statistic?.goals_sum || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      голевых передач
    </div>
    <div class="value">{{ statistic?.assists_sum || 0 }}</div>
  </div>
  <div class="item">
    <div class="name">
      Количество
      <br />
      игровых дней
    </div>
    <div class="value">{{ statistic?.game_days || 0 }}</div>
  </div>
</div>

<div class="join">
  Присоединяйся к Футбольной Лиге "Трудовые резервы"
  <a href="javascript:;" class="btn" (click)="openJoinForm()">Присоединиться</a>
</div>
